import classNames from 'classnames';
import React, { Suspense } from 'react';

import './FavoriteAccount.scss';

const FavoriteAccountSvg = React.lazy(() => import(`./FavoriteAccountSvg`));

interface Props {
    mini?: boolean;
    borderRadius?: boolean;
}

const SkeletonImage: React.FC<Props> = ({ mini, borderRadius }) => (
    <svg
        viewBox={`0 0 320 ${mini ? '200' : '320'}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={classNames('favorite-account-img', { 'border-radius': borderRadius })}
    >
        <g>
            <path d="M0 0H320V320H0V0Z" fill="var(--card-background)" />
        </g>
    </svg>
);

const FavoriteAccountImg: React.FC<Props> = ({ mini, borderRadius }) => {
    return (
        <Suspense fallback={<SkeletonImage mini={mini} borderRadius={borderRadius} />}>
            <FavoriteAccountSvg mini={mini} borderRadius={borderRadius} />
        </Suspense>
    );
};

export default FavoriteAccountImg;
